import PropTypes from 'prop-types';
import React, { useContext } from 'react';
import { I18nContext } from '@bingads-webui-react/i18n-context';
import {
  Card,
  Subtitle1,
  Subtitle2,
  makeStyles,
} from '@fluentui/react-components';
import { OverviewTable } from './overview-table';

const useStyles = makeStyles({
  card: {
    marginBottom: '12px',
    paddingBottom: '24px',
  },
  cards: {
    marginTop: '15px',
  },
  heading: {
    marginTop: '24px !important',
  },
});

export const CampaignOverviewSection = ({
  conversionData,
  measurementTypes,
  searchData,
  visitData,
}) => {
  const styles = useStyles();

  const i18n = useContext(I18nContext);
  const sectionTitle = i18n.getString(_TL_('Campaign overview'));
  const searchLiftTitle = i18n.getString(_TL_('Search lift'));
  const visitLiftTitle = i18n.getString(_TL_('Visit lift'));
  const conversionLiftTitle = i18n.getString(_TL_('Conversion lift'));
  const campaignNameColumnHeader = i18n.getString(_TL_('Campaign'));
  const { useConversionLift, useSearchLift, useVisitLift } = measurementTypes;

  return (
    <div className="campaign-overview">
      <Subtitle1 className={styles.heading}>{sectionTitle}</Subtitle1>
      <div className={styles.cards}>
        {useSearchLift && (
          <Card className={styles.card}>
            <Subtitle2>{searchLiftTitle}</Subtitle2>
            <OverviewTable
              items={searchData}
              liftHelpTopic="pop_BA_Experiments_Campaigns_SearchLift"
              primaryColumnHeader={campaignNameColumnHeader}
              primaryColumnHelpTopic="pop_BA_Experiments_LiftCampaignName"
              title={searchLiftTitle}
            />
          </Card>
        )}
        {useVisitLift && (
          <Card className={styles.card}>
            <Subtitle2>{visitLiftTitle}</Subtitle2>
            <OverviewTable
              items={visitData}
              liftHelpTopic="pop_BA_Experiments_Campaigns_VisitLift"
              primaryColumnHeader={campaignNameColumnHeader}
              primaryColumnHelpTopic="pop_BA_Experiments_LiftCampaignName"
              title={visitLiftTitle}
            />
          </Card>
        )}
        {useConversionLift && (
          <Card className={styles.card}>
            <Subtitle2>{conversionLiftTitle}</Subtitle2>
            <OverviewTable
              items={conversionData}
              liftHelpTopic="pop_BA_Experiments_Campaigns_ConversionLift"
              primaryColumnHeader={campaignNameColumnHeader}
              primaryColumnHelpTopic="pop_BA_Experiments_LiftCampaignName"
              title={conversionLiftTitle}
            />
          </Card>
        )}
      </div>
    </div>
  );
};

CampaignOverviewSection.propTypes = {
  conversionData: PropTypes.arrayOf(PropTypes.shape({
    id: PropTypes.number.isRequired,
    name: PropTypes.string.isRequired,
    confidence: PropTypes.string.isRequired,
    control: PropTypes.number.isRequired,
    lift: PropTypes.number.isRequired,
    treatment: PropTypes.number.isRequired,
  })).isRequired,
  measurementTypes: PropTypes.shape({
    useConversionLift: PropTypes.bool.isRequired,
    useSearchLift: PropTypes.bool.isRequired,
    useVisitLift: PropTypes.bool.isRequired,
  }).isRequired,
  searchData: PropTypes.arrayOf(PropTypes.shape({
    id: PropTypes.number.isRequired,
    name: PropTypes.string.isRequired,
    confidence: PropTypes.string.isRequired,
    control: PropTypes.number.isRequired,
    lift: PropTypes.number.isRequired,
    treatment: PropTypes.number.isRequired,
  })).isRequired,
  visitData: PropTypes.arrayOf(PropTypes.shape({
    id: PropTypes.number.isRequired,
    name: PropTypes.string.isRequired,
    confidence: PropTypes.string.isRequired,
    control: PropTypes.number.isRequired,
    lift: PropTypes.number.isRequired,
    treatment: PropTypes.number.isRequired,
  })).isRequired,
};
